import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import { GetAllEInvoiceEWayBillListType } from "../../../commonTypes/listing";
import {
  getAllEInvoiceEWayBillListAction,
  resetAllEwayBillEInvoiceList,
  resetListingError,
  resetListingSuccess,
} from "../../../redux/listing";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
} from "../../../components/commons";
import { EwayBillListType } from "../../../redux/listing/listingTypes";
import { E_WAY_BILL_REPOST_HEADERS } from "../../../constant/tableHeadersConstants/ewayAndEInvoiceHeaderConst";
import EwayBillTable from "../../../components/AdminReports/EwayBillAndEInvoiceReport/EwayBillTable";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import AllClientScheduleFilter from "../../../components/Scheduling/ScheduleReports/AllClientsReports/AllClientScheduleFilter";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";
import useDebounce from "../../../customHooks/useDebounce";
import { getClientDirectoryListAction } from "../../../redux/clientDirectory";
import { GetClientDirectoryListPayloadType } from "../../../commonTypes/clientDirectoryTypes";

export type ClientListType = {
  value: number | undefined | null;
  label: string | null;
};

type AppProps = {
  history: any;
  token: null | string;
  error: null | string;
  statusCode: null | number;
  dispatchGetAllEInvoiceEWayBillListAction: (
    data: GetAllEInvoiceEWayBillListType
  ) => void;
  allEwayBillEInvoiceList: EwayBillListType[] | [];
  fetching: boolean;
  success: null | number;
  clientDirectoryFetching: boolean;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
  totalClientCount: any;
  clientDirectoryList: [] | ClientDirectoryListType[];
  dispatchResetAllEwayBillEInvoiceList: () => void;
  dispatchResetSession: () => void;
  dispatchResetListingErrorAction: () => void;
  dispatchResetListingSuccessAction: () => void;
};
const AllEwayBillList = ({
  history,
  token,
  error,
  fetching,
  statusCode,
  dispatchGetAllEInvoiceEWayBillListAction,
  allEwayBillEInvoiceList,
  clientDirectoryFetching,
  dispatchGetClientDirectoryListAction,
  totalClientCount,
  clientDirectoryList,
  dispatchResetAllEwayBillEInvoiceList,
  success,
  dispatchResetSession,
  dispatchResetListingErrorAction,
  dispatchResetListingSuccessAction,
}: AppProps) => {
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [finalClientList, setFinalClientList] = useState<ClientListType[] | []>(
    []
  );
  const [clientSelected, setClientSelected] = useState<ClientListType>({
    value: null,
    label: "Select Client...",
  });
  const [filter, setFilter] = useState<number | null | undefined>(null);
  const [text, setText] = useState<string>("");
  const [loadCondition, setLoadCondition] = useState(true);

  useEffect(() => {
    dispatchResetListingErrorAction();
    dispatchResetListingSuccessAction();
    dispatchResetAllEwayBillEInvoiceList();
  }, []);

  useEffect(() => {
    let finalData = {
      token,
      list_type: "E-Way-Bill",
      type: "eway_bill",
    };

    dispatchGetAllEInvoiceEWayBillListAction(finalData);
  }, []);

  useEffect(() => {
    if (clientDirectoryList?.length) {
      if (offset <= +totalClientCount) {
        let finalClientData = clientDirectoryList?.map((e: any) => {
          return {
            value: e?.client_code,
            label: `(${e?.client_code}) ${e?.company_name}`,
          };
        });
        if (offset > 0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientDirectoryList]);

  useEffect(() => {
    if (token && totalClientCount) {
      if (offset <= +totalClientCount) {
        const finalData = {
          token,
          status: 1,
          offset,
          limit,
          searchValue: text,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    }
  }, [offset]);

  const handleChangeClient = (client: any) => {
    setClientSelected(client);
  };

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv) => prv + limit);
  };

  const fetchNewData = () => {
    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        searchValue: text,
        status: 1,
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  };

  useDebounce(
    () => {
      fetchNewData();
    },
    500,
    [text]
  );

  const onMenuClose = () => setLoadCondition(true);

  const handleFilter = (type?: string) => {
    if (type != "clear") {
      setFilter(clientSelected?.value);

      if (token && clientSelected?.value) {
        dispatchResetAllEwayBillEInvoiceList();
        let finalData = {
          token,
          list_type: "E-Way-Bill",
          client_code: clientSelected?.value,
          type: "eway_bill",
        };

        dispatchGetAllEInvoiceEWayBillListAction(finalData);
      }
    } else {
      setFilter(null);
      if (token && clientSelected?.value) {
        dispatchResetAllEwayBillEInvoiceList();
        let finalData = {
          token,
          list_type: "E-Way-Bill",
          type: "eway_bill",
          // client_code: clientSelected?.value,
        };

        dispatchGetAllEInvoiceEWayBillListAction(finalData);
      }
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAllEwayBillEInvoiceList();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="E-Way Bill " />
      </div>
      <div className="col-md-12">
        <div className="jobs-card ">
          <div className="header">
            <div className="left-header">
              <div className="heading"> E-Way Bill List</div>
            </div>
            <div>
              <div className="mr-3">
                <AllClientScheduleFilter
                  clientSelected={clientSelected}
                  finalClientList={finalClientList}
                  handleChangeClient={handleChangeClient}
                  checkBottom={checkBottom}
                  clientDirectoryFetching={clientDirectoryFetching}
                  onMenuClose={onMenuClose}
                  setText={setText}
                  setOffset={setOffset}
                  loadCondition={loadCondition}
                  setLoadCondition={setLoadCondition}
                  handleFilter={handleFilter}
                  setClientSelected={setClientSelected}
                  filter={filter}
                  setFilter={setFilter}
                />
              </div>
            </div>
          </div>
          {/* <hr></hr> */}
          <div>
            {fetching ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : allEwayBillEInvoiceList?.length > 0 ? (
              <div className="new-table-style" style={{ overflow: "auto" }}>
                <table className="table thead-light table-bordered">
                  <thead className="text-start sticky-table-header">
                    <TableHeader
                      tableHeader={E_WAY_BILL_REPOST_HEADERS}
                      // extraHeader
                    />
                  </thead>
                  <tbody>
                    <EwayBillTable
                      data={allEwayBillEInvoiceList}
                      tableHeaders={E_WAY_BILL_REPOST_HEADERS}
                    />
                  </tbody>
                </table>
                <div style={{ display: fetching ? "none" : "inline" }}>
                  <ScrollToTop />
                </div>
              </div>
            ) : (
              <>
                {fetching === false &&
                  allEwayBillEInvoiceList?.length === 0 && (
                    <EmptyListPage title="No Data Found !" imageWidth="30%" />
                  )}
              </>
            )}
          </div>
        </div>
      </div>
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  success: state.listing.success,
  fetching: state.listing.fetching,
  token: state.auth.token,
  error: state.listing.error,
  statusCode: state.listing.statusCode,
  allEwayBillEInvoiceList: state.listing.allEwayBillEInvoiceList,
  clientDirectoryFetching: state.clientDirectory.fetching,
  totalClientCount: state.clientDirectory.totalCount,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetAllEInvoiceEWayBillListAction: (
    data: GetAllEInvoiceEWayBillListType
  ) => dispatch(getAllEInvoiceEWayBillListAction(data)),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
  dispatchResetAllEwayBillEInvoiceList: () =>
    dispatch(resetAllEwayBillEInvoiceList()),
  dispatchResetListingErrorAction: () => dispatch(resetListingError()),
  dispatchResetListingSuccessAction: () => dispatch(resetListingSuccess()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllEwayBillList);
